import { APP_ID, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { ApolloModule } from 'apollo-angular';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { apolloProvider } from '@awread/global/apollo';
import { environment } from '@awread/global/environments';
import { MetaTagService, ReuseStrategyService } from '@awread/kernel/services';
import { AppTitleStrategy } from './app-title.strategy.js';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';
import { provideDialogConfig } from '@ngneat/dialog';
import localeVi from '@angular/common/locales/vi';
import { registerLocaleData } from '@angular/common';
import { AdsenseModule } from 'ng2-adsense';

// registerLocaleData(localeVi);

export const globalProvider = [
  importProvidersFrom(AdsenseModule.forRoot({
    adClient: 'ca-pub-7075306512981303',
    adSlot: 2642089839,
  })),
  // { provide: LOCALE_ID, useValue: 'vi' },
  environment.production ? [] : importProvidersFrom(AkitaNgDevtools.forRoot()),
  provideDialogConfig({
    windowClass: 'bg-base-100',
    sizes: {
      // sm: {
      //   minHeight: '360px',
      // },
      // md là size mặc định của mọi dialog. Mặc định gốc hẹp nên nội dung nhiều cột
      // (lưới mệnh giá nạp, QR, khối chuyển khoản tay) bị bó và nhảy layout.
      md: {
        width: '34rem',
      },
      // lg: {
      //   minHeight: '1080px',
      // },
      fullscreen: {
        height: '100vh',
        width: '100vw',
      },
    },
  }),
  importProvidersFrom(ApolloModule),
  provideHttpClient(),
  MetaTagService,
  apolloProvider,
  { provide: TitleStrategy, useClass: AppTitleStrategy },
  { provide: RouteReuseStrategy, useClass: ReuseStrategyService },
];
